import React from "react";
import { useMobile } from "./MobileContext";

const withMobile = (WrappedComponent) => {
  return function WithMobile(props) {
    // Use the useMobile hook to get the isMobile value
    const { isMobile } = useMobile();

    // Pass the isMobile value as a prop to the wrapped component
    return <WrappedComponent isMobile={isMobile} {...props} />;
  };
};

export default withMobile;
